import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-warm-gradient px-4 py-20" data-id="element-136">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-137">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left z-10" data-id="element-138">
          <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-wider text-terracotta uppercase bg-terracotta/10 rounded-full" data-id="element-139">
            Para madres primerizas
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-brown" data-id="element-140">
            Deja de pelear por la crianza.{' '}
            <span className="italic text-terracotta" data-id="element-141">
              Empieza a acordar en 10 minutos.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-brown-light mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-142">
            El método <span className="font-semibold" data-id="element-143">Acuerdos Express</span>{' '}
            para madres primerizas que quieren paz en su hogar, sin terapias
            eternas ni libros interminables.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-144">
            <motion.a href="#pricing" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 bg-terracotta text-white rounded-full font-medium text-lg shadow-lg shadow-terracotta/30 hover:bg-terracotta-dark transition-colors flex items-center gap-2" onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-145">
              Quiero mi guía
            </motion.a>

            <p className="text-sm text-brown-light/80 italic" data-id="element-146">
              Descarga inmediata • Acceso de por vida
            </p>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        x: 30,
        rotate: 2
      }} animate={{
        opacity: 1,
        x: 0,
        rotate: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative z-10" data-id="element-147">
          <div className="relative" data-id="element-148">
            {/* Decorative blob background */}
            <div className="absolute -inset-4 bg-blush/30 rounded-full blur-3xl transform rotate-12 scale-110 -z-10" data-id="element-149"></div>

            <img src="https://cdn.magicpatterns.com/uploads/h6bU94vz1gvQZ4yefLgedW/heylloyd-image-1771052262180.png" alt="Guía Acuerdos Express en tablet sobre una cama acogedora" className="w-full max-w-md mx-auto rounded-2xl shadow-2xl border-4 border-white transform hover:-rotate-1 transition-transform duration-500" data-id="element-150" />

            {/* Floating badge */}
            <motion.div initial={{
            scale: 0,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} transition={{
            delay: 1,
            type: 'spring'
          }} className="absolute -bottom-6 -right-6 md:bottom-10 md:-right-10 bg-white p-4 rounded-xl shadow-xl max-w-[180px] hidden sm:block" data-id="element-151">
              <div className="flex items-center gap-2 mb-1" data-id="element-152">
                <div className="flex -space-x-2" data-id="element-153">
                  {[1, 2, 3].map(i => <div key={i} className="w-8 h-8 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-xs font-bold text-brown" data-id="element-154">
                      {String.fromCharCode(64 + i)}
                    </div>)}
                </div>
                <span className="text-xs font-bold text-terracotta" data-id="element-155">
                  +500 mamás
                </span>
              </div>
              <p className="text-xs text-brown-light leading-tight" data-id="element-156">
                Ya están recuperando la paz en su hogar.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>

      {/* Soft overlay at bottom to blend into next section */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-cream to-transparent pointer-events-none" data-id="element-157"></div>
    </section>;
}